import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";
import { Reveal, EASE } from "@/components/Reveal";

export function Collections() {
  const [cols, setCols] = useState([]);

  useEffect(() => {
    api.get("/collections").then(({ data }) => setCols(data)).catch(() => {});
  }, []);

  // bento layout classes per index
  const spanClass = [
    "md:col-span-2 md:row-span-2", // new arrivals - big
    "md:col-span-2", // best sellers
    "md:col-span-1", // necklaces
    "md:col-span-1", // earrings
    "md:col-span-2", // bracelets
    "md:col-span-2", // rings
  ];

  return (
    <section className="mx-auto max-w-[1400px] px-5 py-24 md:px-10 md:py-32" data-testid="collections">
      <Reveal className="mb-14 flex flex-col justify-between gap-4 md:flex-row md:items-end">
        <div>
          <p className="eyebrow text-gold">Curated For You</p>
          <h2 className="mt-4 font-serif text-4xl font-light leading-none tracking-tight text-ink md:text-6xl">
            Shop by Collection
          </h2>
        </div>
        <Link to="/shop" className="eyebrow link-underline text-ink/70" data-testid="collections-view-all">
          View All Jewelry
        </Link>
      </Reveal>

      <div className="grid grid-cols-2 gap-4 md:auto-rows-[280px] md:grid-cols-4">
        {cols.map((c, i) => (
          <motion.div
            key={c.slug}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, ease: EASE, delay: (i % 4) * 0.06 }}
            className={`group relative overflow-hidden rounded-2xl ${spanClass[i] || ""}`}
          >
            <Link to={`/collection/${c.slug}`} data-testid={`collection-card-${c.slug}`} className="block h-full">
              <img
                src={c.image}
                alt={c.name}
                loading="lazy"
                className="h-full min-h-[200px] w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/55 via-ink/5 to-transparent" />
              <div className="absolute inset-0 flex flex-col justify-end p-6">
                <p className="eyebrow text-ivory/70">{c.tagline}</p>
                <div className="mt-1 flex items-center justify-between">
                  <h3 className="font-serif text-2xl text-ivory md:text-3xl">{c.name}</h3>
                  <span className="grid h-9 w-9 place-items-center rounded-full bg-ivory/90 text-ink transition-transform duration-300 group-hover:rotate-45">
                    <ArrowUpRight size={16} strokeWidth={1.5} />
                  </span>
                </div>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
